import { render } from "./InplayView.vue?vue&type=template&id=bc744fe4"
import script from "./InplayView.vue?vue&type=script&lang=js"
export * from "./InplayView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__